module.exports = __webpack_public_path__ + "a768e7de/img/cadBim.e369a02a.png";